import React, { useMemo } from "react";
import { Card,CardBody,Col} from "reactstrap";
import { BsCheckCircle } from "react-icons/bs";
import { ReactComponent as CrossIcon } from "../../../../../assets/utils/images/svgs/Cross.svg";
import ReactTableGenericForUsers from "Components/ReactTableGenericForUsers";
import { Link } from "react-router-dom";

function Table(props) {

    const columns = useMemo(() => (
        [
            {
                header: () => <div className="documnent-table-fr">Naam</div>,
                accessorKey: "name",
                cell: (value) => <Link to={`/gebruikers/${value.row.original?.clooserId}`} target="_blank" rel="noopener noreferrer"  >
                        {value.row.original?.name}
                    </Link>
            },
            {
                header: () => "Clooser ID",
                accessorKey: "clooserId",
            },
            {
                header: () => "Salaris-id",
                accessorKey: "vSalarisId",
            },
            {
                header: () => "Contracttype",
                accessorKey: "contracttype",
            },
            {
                header: () => <div className="text-center">Eerste inzet</div>,
                accessorKey: "errset",
                cell: (value) => <div className="text-center">
                    {value.row.original?.errset ?
                        <BsCheckCircle color="#39A825" /> : <CrossIcon />
                    }
                </div>
            },
            {
                header: () => <div className="text-center">Nieuwe documenten</div>,
                accessorKey: "newDoc",
                cell: (value) => <div className="text-center">
                    {value.row.original?.newDoc ?
                        <BsCheckCircle color="#39A825" /> : <CrossIcon />
                    }
                </div>
            },
        ]
    ), []);

    const paginate = (val) => {
        props.setPageNumber(val);
        props.setPayload((prev) => {
            return {
                ...prev,
                page: val,
            };
        });
    };

    const handleInputChange = (val) => {
        props.setPageNumber(1);
    };

    const filterList = (val) => {
        handleInputChange(val);
    };

    const indexPageSize = (val) => {
        props.setPageSizeCount(val);
    };

    const userTablePageSize = (val) => {
        props.setPageNumber(1);
        indexPageSize(val);
        props.setPayload((prev) => {
            return {
                ...prev,
                pageSize: val,
            };
        });
    };

    return (<Col sm={12}>
        <div className="row">
            <div className="col">
                <Card className="main-card mb-3">
                    <CardBody className="p-3">
                        <ReactTableGenericForUsers
                            data={props?.data}
                            columns={columns}
                            setPageNumber={props.setPageNumber}
                            pageNumber={props.pageNumber}
                            totalPageCount={props.totalPageCount}
                            filters={{ search: false }}
                            paginate={paginate}
                            filterList={filterList}
                            userTablePageSize={userTablePageSize}
                            pageSizeCount={props.pageSizeCount}
                            showLoader={props.showLoader}
                            count={props.totalCount}
                            tableClassName="mb-0 table table-borderless table-sm table-hover table-heading-style documnent-table"
                        />
                    </CardBody>
                </Card>
            </div>
        </div>
    </Col>)
}

export default Table;